import { useMemo } from 'react';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { useGetPresaveCampaignQuery } from '../../../redux/api/fymAPI';
import { findPresaveWidget } from './findPresaveWidget';

interface UsePresaveCampaignProps {
  accountId: number;
  smartLink: SerializedSmartLink;
}

/**
 * Resolves the campaign behind a loaded SmartLink.
 *
 * The page gives us the campaign's uuid and never its numeric id, so the read
 * endpoint is called with the uuid — it accepts either. The numeric id comes
 * back on the campaign and is what the release call then uses.
 */
export function usePresaveCampaign({ accountId, smartLink }: UsePresaveCampaignProps) {
  const widget = useMemo(() => findPresaveWidget(smartLink), [smartLink]);
  const campaignUuid = widget?.data.campaignUuid;

  const { data, isLoading, error, refetch } = useGetPresaveCampaignQuery(
    { accountId, campaignId: campaignUuid ?? '' },
    { skip: campaignUuid === undefined }
  );

  return {
    hasPresaveBlock: widget !== undefined,
    /** The services the block offers, for the checklist and the per-service split. */
    services: widget?.data.services ?? [],
    campaignUuid,
    campaign: data?.campaign,
    stats: data?.stats,
    isLoading,
    error,
    refetch,
  };
}
